import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const Wrapper = styled.div`
  line-height: 100%;
  padding: 15px 25px;
`
export const SubWrapper = styled.div`
  margin-bottom: 50px;
`
export const HeaderFlex = styled(Flex)`
  gap: 10px;
`
export const UserName = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XL};
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`
export const SubHeading = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: #000000;
  margin-bottom: 30px;
`

export const CardRow = styled(Flex)`
  gap: 25px;
  margin: 30px 0;
`
